import React from "react";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";

export default class Joiningbonus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
    };
  }
  componentDidMount() {
    this.GetTransactions();
  }
  async GetTransactions() {
    let res = await ApiRequest("GetJoiningBonusReport.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      tableData: res.items,
    });
  }
  //GetJoiningBonusDetails.asp
  render() {
    return (
      <div>
        <PageHeader title="Affiliate Bonus" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3
                  className="card-title text-color-1"
                  style={{ fontWeight: "200", fontSize: "22px" }}
                >
                  Affiliate Bonus
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                    style={{ textAlign: "center" }}
                  >
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        <th>Username</th>
                        <th>Income</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.tableData.length <= 0 ? (
                        <tr>
                          <td colSpan="4">No Details Found</td>
                        </tr>
                      ) : (
                        this.state.tableData.map((item, index) => (
                          <tr key={index}>
                            <td className="tabletd">{index + 1}</td>
                            <td>{item.payoutdate}</td>
                            <td>{item.forwhom}</td>
                            <td>{item.payout}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
